// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Next = require("../../../reason/next/Next.bs.js");
var React = require("react");
var Loader = require("../../../uikit/reason/atoms/Loader/Loader.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var ConversationsPageRelayCommon = require("./ConversationsPageRelayCommon.bs.js");
var ConversationParticipantsDisplay = require("./ConversationParticipantsDisplay.bs.js");
var ConversationPageNotAnonymousWarning = require("./ConversationPageNotAnonymousWarning.bs.js");
var ConversationPageConversationMessages = require("./ConversationPageConversationMessages.bs.js");
var ConversationPageSelectedConversationContext = require("./ConversationPageSelectedConversationContext.bs.js");
var ConversationPageSelectedConversationMatches = require("./ConversationPageSelectedConversationMatches.bs.js");
var ConversationPageNewConversationQuery_graphql = require("../../../__generated__/ConversationPageNewConversationQuery_graphql.bs.js");
var Conversation__ConversationsSection__StartFirstConversation = require("../conversationsSection/Conversation__ConversationsSection__StartFirstConversation.bs.js");
var ConversationPageNewConversationByType_conversationContext_graphql = require("../../../__generated__/ConversationPageNewConversationByType_conversationContext_graphql.bs.js");
var ConversationPageNewConversationDisplayer_conversationContext_graphql = require("../../../__generated__/ConversationPageNewConversationDisplayer_conversationContext_graphql.bs.js");

var convertVariables = ConversationPageNewConversationQuery_graphql.Internal.convertVariables;

var convertResponse = ConversationPageNewConversationQuery_graphql.Internal.convertResponse;

var convertWrapRawResponse = ConversationPageNewConversationQuery_graphql.Internal.convertWrapRawResponse;

var use = RescriptRelay_Query.useQuery(convertVariables, ConversationPageNewConversationQuery_graphql.node, convertResponse);

var useLoader = RescriptRelay_Query.useLoader(convertVariables, ConversationPageNewConversationQuery_graphql.node, (function (prim) {
        return prim;
      }));

var usePreloaded = RescriptRelay_Query.usePreloaded(ConversationPageNewConversationQuery_graphql.node, convertResponse, (function (prim) {
        return prim;
      }));

var $$fetch = RescriptRelay_Query.$$fetch(ConversationPageNewConversationQuery_graphql.node, convertResponse, convertVariables);

var fetchPromised = RescriptRelay_Query.fetchPromised(ConversationPageNewConversationQuery_graphql.node, convertResponse, convertVariables);

var retain = RescriptRelay_Query.retain(ConversationPageNewConversationQuery_graphql.node, convertVariables);

var Query_conversationContextTypeV5_decode = ConversationPageNewConversationQuery_graphql.Utils.conversationContextTypeV5_decode;

var Query_conversationContextTypeV5_fromString = ConversationPageNewConversationQuery_graphql.Utils.conversationContextTypeV5_fromString;

var Query_membershipStatusV5_decode = ConversationPageNewConversationQuery_graphql.Utils.membershipStatusV5_decode;

var Query_membershipStatusV5_fromString = ConversationPageNewConversationQuery_graphql.Utils.membershipStatusV5_fromString;

var Query_messageBroadcasStatus_decode = ConversationPageNewConversationQuery_graphql.Utils.messageBroadcasStatus_decode;

var Query_messageBroadcasStatus_fromString = ConversationPageNewConversationQuery_graphql.Utils.messageBroadcasStatus_fromString;

var Query = {
  conversationContextTypeV5_decode: Query_conversationContextTypeV5_decode,
  conversationContextTypeV5_fromString: Query_conversationContextTypeV5_fromString,
  membershipStatusV5_decode: Query_membershipStatusV5_decode,
  membershipStatusV5_fromString: Query_membershipStatusV5_fromString,
  messageBroadcasStatus_decode: Query_messageBroadcasStatus_decode,
  messageBroadcasStatus_fromString: Query_messageBroadcasStatus_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  $$fetch: $$fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

var convertFragment = ConversationPageNewConversationDisplayer_conversationContext_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationPageNewConversationDisplayer_conversationContext_graphql.node, convertFragment, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationPageNewConversationDisplayer_conversationContext_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, ConversationPageNewConversationDisplayer_conversationContext_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ConversationPageNewConversationDisplayer_conversationContext_graphql.node, convertFragment, fRef);
}

var ConversationContextFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use$1,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

var convertFragment$1 = ConversationPageNewConversationByType_conversationContext_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationPageNewConversationByType_conversationContext_graphql.node, convertFragment$1, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationPageNewConversationByType_conversationContext_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, ConversationPageNewConversationByType_conversationContext_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(ConversationPageNewConversationByType_conversationContext_graphql.node, convertFragment$1, fRef);
}

var ByTypeFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$2,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function ConversationPageNewConversation$Displayer(props) {
  var contextForConversation = props.contextForConversation;
  var conversationContext = use$1(props.conversationContext);
  var byType = use$2(conversationContext.fragmentRefs);
  var router = Next.useRouter();
  var match = React.useState(function () {
        return false;
      });
  var setShowLoadingIndicator = match[1];
  var tmp;
  switch (byType.__typename) {
    case "ForSalePropertyV5" :
        var match$1 = byType.agentV2;
        if (match$1 !== undefined) {
          switch (match$1.__typename) {
            case "AnonymousForSalePropertyAgent" :
                tmp = ["AnonymousConversationParticipant"];
                break;
            case "VisibleForSalePropertyAgent" :
                var match$2 = match$1.agent;
                tmp = match$2 !== undefined ? [{
                      TAG: "Agent",
                      id: match$2.id,
                      fragmentRefs: match$2.fragmentRefs,
                      displayName: match$2.displayName
                    }] : [];
                break;
            case "__unselected" :
                tmp = [];
                break;
            
          }
        } else {
          tmp = [];
        }
        break;
    case "__unselected" :
        tmp = [];
        break;
    default:
      var match$3 = byType.agent;
      tmp = match$3 !== undefined ? [{
            TAG: "Agent",
            id: match$3.id,
            fragmentRefs: match$3.fragmentRefs,
            displayName: match$3.displayName
          }] : [];
  }
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(ConversationParticipantsDisplay.ByParticipants.make, {
                            participants: tmp
                          })
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(ConversationPageSelectedConversationContext.make, {
                            conversationContext: contextForConversation
                          })
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(ConversationPageSelectedConversationMatches.make, {
                            conversationContext: contextForConversation
                          })
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("div", {
                                    children: JsxRuntime.jsx(ConversationPageConversationMessages.MessagesContainer.make, {
                                          children: match[0] ? JsxRuntime.jsx("div", {
                                                  children: JsxRuntime.jsx(Loader.make, {
                                                        size: "medium"
                                                      }),
                                                  className: "p-4"
                                                }) : null
                                        })
                                  }),
                              JsxRuntime.jsx("div", {
                                    children: JsxRuntime.jsx(ConversationPageNotAnonymousWarning.make, {
                                          conversationContext: contextForConversation,
                                          isNewConversation: true
                                        }),
                                    className: "mt-4 mb-8 p-4"
                                  }),
                              JsxRuntime.jsx("div", {
                                    children: JsxRuntime.jsx(Conversation__ConversationsSection__StartFirstConversation.make, {
                                          context: conversationContext.fragmentRefs,
                                          onStartedInitiatingConversation: (function () {
                                              setShowLoadingIndicator(function (param) {
                                                    return true;
                                                  });
                                            }),
                                          onConversationInitiated: (function (newConversationId) {
                                              Next.Router.replace("/conversations/" + newConversationId, undefined, undefined, router);
                                            })
                                        })
                                  })
                            ]
                          })
                    })
              ],
              className: "p-4 flex flex-col space-y-4"
            });
}

var Displayer = {
  ConversationContextFragment: ConversationContextFragment,
  ByTypeFragment: ByTypeFragment,
  StartFirstConversation: undefined,
  make: ConversationPageNewConversation$Displayer
};

function ConversationPageNewConversation(props) {
  var data = use({
        entityType: props.entityType,
        id: props.entityId
      }, undefined, undefined, undefined);
  var conversationContext = data.newConversationContextV5;
  var tmp;
  if (conversationContext !== undefined) {
    var context = conversationContext.context;
    var tmp$1;
    var exit = 0;
    var displayName;
    var context$1 = conversationContext.context;
    if (context$1 !== undefined) {
      var match = context$1.agent;
      var exit$1 = 0;
      var exit$2 = 0;
      if (match !== undefined) {
        var tmp$2 = match.membershipStatus;
        if ((tmp$2 === "ACTIVE" || tmp$2 === "TERMINATED") && tmp$2 !== "ACTIVE") {
          displayName = match.displayName;
          exit = 1;
        } else {
          exit$2 = 3;
        }
      } else {
        exit$2 = 3;
      }
      if (exit$2 === 3) {
        var match$1 = context$1.agentV2;
        var exit$3 = 0;
        if (match$1 !== undefined && match$1.__typename === "VisibleForSalePropertyAgent") {
          var match$2 = match$1.agent;
          if (match$2 !== undefined) {
            var tmp$3 = match$2.membershipStatus;
            if ((tmp$3 === "ACTIVE" || tmp$3 === "TERMINATED") && tmp$3 !== "ACTIVE") {
              displayName = match$2.displayName;
              exit = 1;
            } else {
              exit$3 = 4;
            }
          } else {
            exit$3 = 4;
          }
        } else {
          exit$3 = 4;
        }
        if (exit$3 === 4) {
          var match$3 = context$1.messageBroadcastStatus;
          if (match$3 !== undefined && (match$3 === "PUBLISHED" || match$3 === "EXPIRED" || match$3 === "DRAFT" || match$3 === "DELETED" || match$3 === "RESUMABLE_DRAFT") && match$3 === "DELETED") {
            tmp$1 = JsxRuntime.jsx("div", {
                  children: "The broadcast message has been deleted",
                  className: "p-2"
                });
          } else {
            exit$1 = 2;
          }
        }
        
      }
      if (exit$1 === 2) {
        tmp$1 = JsxRuntime.jsx(ConversationPageNewConversation$Displayer, {
              conversationContext: context$1.fragmentRefs,
              contextForConversation: conversationContext.fragmentRefs
            });
      }
      
    } else {
      tmp$1 = null;
    }
    if (exit === 1) {
      tmp$1 = JsxRuntime.jsx("div", {
            children: "Unable to message as " + displayName + " no longer has an active subscription on TAN",
            className: "p-2"
          });
    }
    tmp = JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [
            context !== undefined ? JsxRuntime.jsx(ConversationsPageRelayCommon.RecordPageView.ConversationViewByConversationContext.make, {
                    conversationContext: Caml_option.some(context.fragmentRefs),
                    activeConversationId: props.originalConversationId
                  }) : null,
            tmp$1
          ]
        });
  } else {
    tmp = null;
  }
  return JsxRuntime.jsx(JsxRuntime.Fragment, {
              children: Caml_option.some(tmp)
            });
}

var make = ConversationPageNewConversation;

exports.Query = Query;
exports.Displayer = Displayer;
exports.make = make;
/* use Not a pure module */
